import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VeeValidate from 'vee-validate'
import yandexMap from 'vue-yandex-maps'
import '../../components/components'

import './../less/crystal-space.less'

import './lightbox'
import './map'
import './sale-page'
import './popover'
import './gifplayer'
Vue.use(VueResource);
Vue.use(yandexMap);
Vue.use(VeeValidate);
Vue.http.options.emulateJSON = true;
new Vue({el: '#galactium'});
UIkit.use(Icons);


(function ($) {
    $('.gif').gifplayer();
    var searchblock = $('.tm-search-l-screen');
    var searchinput = $('input.uk-search-input');
    var searchbutton = $('.uk-search-icon-flip.uk-search-icon');
    var i = !1;
    var timeout_id = {};
    searchinput.focus(function(){
            clearTimeout(timeout_id);
            searchblock.addClass("search-active");
            searchblock.css({'position' : 'absolute', 'right' : '0'});
    });
    searchinput.blur(function(){
        if(i == !1){
            searchblock.removeClass("search-active");
            timeout_id = setTimeout(function() {searchblock.removeAttr('style');}, 500);
        }
    });
    searchbutton.mousedown(function(){
        i = !0;
    }
    );
})(jQuery);



// WEBPACK FOOTER //
// ./assets/js/crystal-space.js